import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Globe, Download, Copy } from "lucide-react";
import { toast } from "sonner";

// URL pubblico di PRODUZIONE per il menù di sola consultazione (ingresso, social, volantini, vetrofanie, Google).
// QR unico, senza token tavolo → nessun self-order.
const PUBLIC_MENU_URL = "https://dogana2.it/menu";

export default function GeneralMenuQRCode() {
  const ref = useRef(null);

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = "qr-menu-generale.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(PUBLIC_MENU_URL); toast.success("Link menù generale copiato"); }
    catch { toast.error("Copia non riuscita"); }
  };

  return (
    <Card className="p-5 rounded-xl flex flex-col sm:flex-row items-center gap-5" data-testid="general-menu-qr-card">
      <div ref={ref} className="bg-white p-3 rounded-lg border border-border">
        <QRCodeCanvas value={PUBLIC_MENU_URL} size={128} fgColor="#1A1A1A" level="M" includeMargin={false} data-testid="general-menu-qr-canvas" />
      </div>
      <div className="flex-1 text-center sm:text-left w-full">
        <div className="flex items-center gap-2 justify-center sm:justify-start text-primary">
          <Globe className="w-5 h-5" />
          <h3 className="font-dash font-semibold text-lg">QR Menù Generale</h3>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          QR unico di sola consultazione (nessun tavolo, nessun ordine). Da usare su ingresso, social, volantini, vetrofanie e Google.
        </p>
        <p className="text-xs text-muted-foreground mt-2 break-all" data-testid="general-menu-qr-url">{PUBLIC_MENU_URL}</p>
        <div className="flex gap-2 mt-3 justify-center sm:justify-start">
          <Button onClick={download} variant="outline" className="rounded-full" data-testid="download-general-qr-button">
            <Download className="w-4 h-4 mr-1" /> Scarica QR
          </Button>
          <Button onClick={copyLink} variant="outline" className="rounded-full" data-testid="copy-general-qr-link-button">
            <Copy className="w-4 h-4 mr-1" /> Copia link
          </Button>
        </div>
      </div>
    </Card>
  );
}
